import {VERSION5_2_3} from "@/lib/version";

const DS_NAVS = [
  {
    name: '信息登记',
    path: 'https://assess.ngarihealth.com/healthWeb-base/views/assess/assessBegin.html?appId=2&appType=4&assessId=19061010420329396619&shareType=0&conType=1'
  },
  {name: '到院导航',},
  {
    name: '手术宣教',
    path: VERSION5_2_3 ? '/daysurgery/news' : 'https://yypt.ngarihealth.com/ehealth-micro-web/MobileHomeIndex?id=1000064',
  },
  {name: '保险中心'},
  {
    name: '手术进度',
  },
  {
    name: '术后宣教',
    path: VERSION5_2_3 ? '/daysurgery/news' : 'https://yypt.ngarihealth.com/ehealth-micro-web/MobileHomeIndex?id=1000064',
  },
  {
    name: '健康随访',
    path: 'https://assess.ngarihealth.com/healthWeb-base/views/assess/assessBegin.html?appId=0&appType=4&hospitalId=1000064&depId=0&assessId=20061610334710204891&shareType=0&conType=1'
  },
  {name: '报告查询'},
  {name: '咨询医生', path: '/internetRoom'},
  {name: '线上续方', path: '/renewal'},
  {name: '护理服务', path: '/zkhl'},
  {name: '联系客服'},
  {name: '陪护申请'},
  {name: '我的陪护证'},
  {name: '住院清单'},
  {name: '预约挂号', path: '/book/rule'},
  {name: '住院预缴金', path: '/butler/select?type=zy'},
  {name: '住院告知书', path: '/news/ysxy?title=住院告知书&type=onlyread'},
  {
    name: '日间宣教',
    path: VERSION5_2_3 ? '/daysurgery/news' : 'https://yypt.ngarihealth.com/ehealth-micro-web/MobileHomeIndex?id=1000064',
  }
].map(r => {
  return {
    ...r,
    icon: require('./assets/navs/' + r.name + '@3x.png')
  }
})

export function getNavsByNames(names) {
  return [...names].map(r => DS_NAVS.find(rr => rr.name === r));
}

/**
 * 日间手术状态
 * @type {{"0": string, "1": string, "2": string, "3": string, "4": string}}
 */
export const SSZT = {
  0: "预入院", 1: "检查/评估", 2: "等通知", 3: "到院手术", 4: "已出院"
}

export function ssztFilter(str) {
  if (!str) return '';
  return SSZT[str] || str;
}

/**
 * 入院类型
 * @type {{"1": string, "2": string, "3": string, "4": string}}
 */
export const RYLX = {
  1: '普通入院',
  2: '办院前',
  3: '预入院',
  4: '日间手术'
}

export function rylxFilter(str) {
  if (!str) return '';
  const title = RYLX[str] || str;
  if (title === '办院前') return RYLX[1];
  return title;
}

/**
 * 入院类型对应的moduleCode
 * @type {{"1": string, "2": string, "3": string, "4": string}}
 */
export const rylx_module_code = {
  1: "ORDINARY_SURGERY",
  2: "BEFORE_SURGERY",
  3: "READY_SURGERY",
  4: "BEFORE_DAY_SURGERY"
}

/**
 * 入院类型对应的宣教模块
 * @type {{"1": string, "2": string, "3": string, "4": string}}
 */
export const rylx_type_name = {
  1: "普通住院宣教",
  2: "办院前宣教",
  3: "预住院宣教",
  4: "日间手术(院前)宣教"
}

/**
 * 入院类型 - 流程状态 - 对应的 描述
 * @type {{"1": string, "2": string, "3": string, "4": string}}
 */
export const rylx_progress_name = {
  1: {
    1: '<p>您已预约住院，请耐心等候，工作人员将以短信或电话通知您入院</p>',
    2: '住院时间：<b>{date}</b><br/>请前往<span class="color_main"><br/>{address}</span><br/>办理办入院手续（请以短信或电话为准 ！）',
    3: '<p>请您按通知入住病区</p>' +
      '<h4 class="mt5"></h4>住院时间：<b>{date}</b><h4 class="mt5"></h4>住院病区：<span class="color_main">{address}</span>'
  },
  2: {
    1: '<p>您已预约住院，请耐心等候，工作人员将以短信或电话通知您入院</p>',
    2: '住院时间：<b>{date}</b><br/>请前往<span class="color_main"><br/>{address}</span><br/>办理办入院手续（请以短信或电话为准 ！）',
    3: '<h4 class="tac"><b>下一步，您需要：</b></h4>',
    4: '<p>请您按通知入住病区</p>' + '<h4 class="mt5"></h4>住院时间：<b>{date}</b><h4 class="mt5"></h4>住院病区：<b class="color_main">{address}</b>'
  },
  3: {
    1: '<h4 class="tac mb10"><b>您已预约住院</b></h4><p class="mb10">请携带医保卡/电子医保凭证、身份证、预入院告知书等，到入院准备中心办理手续（请以短信或电话为准）。<br/></p>地址：<br/><span class="color_main">{address}</span>',
    2: '<h4 class="tac"><b>下一步，您需要：</b></h4>',
    3: '<p>接下来，请保持手机畅通，工作人员将以短信/电话通知您住院。</p>',
    4: '住院时间：<b>{date}</b><br/>住院病区：<b>{address}</b>（请以短信或电话通知为准）'
  },
  4: {
    1: '我们已接收到您的入院申请，请您携带医保卡、身份证、预入院告知书等，请前往<br/><span class="color_main">{address}</span><br/>办理预入院手续，完成预缴费并做检查。',
    2: '接下来，您需要',
    3: '接下来，请保持手机畅通，床位协调中心会通过短信/电话通知您住院!',
    4: '住院时间：<b>{date}</b><br/>住院病区：<b>{address}</b>（请以短信或电话通知为准）'
  }
}

/**
 * 编译title 替换其中的{}包裹的变量
 * @param str
 * @param data
 * @returns {*}
 */
export const compilerRylxProgressTitle = (str, data = {}) => {
  if (!str) return '';
  if (str.includes('{') && str.includes('}')) {
    str = str.replace(/\{(.+?)\}/g, function () {
      let key = arguments[1];
      if (!key) return;
      key = key.trim();
      // Log('data------', data, key, data[key]);
      return data.hasOwnProperty(key) ? data[key] : arguments[0];
    })
    return str;
  } else {
    return str;
  }
}

/**
 * 预住院状态
 * @type {{"0": string, "1": string, "2": string, "3": string, "4": string, "5": string, "6": string, "7": string, "8": string, "9": string, "10": string}}
 */
export const YZYZT = {
  0: '未安排',
  1: '预安排',
  2: '已安排',
  3: '已住院',
  4: '取消住院',
  5: '已登记',
  6: '预住院',
  7: '退住院',
  8: '已入住',
  9: '待退住院',
  10: '已退住院'
}

export function yzyztFilter(str) {
  if (!str) return '';
  return YZYZT[str] || str;
}

export const DHRY_LIST_NAV = [
  {
    name: '查看服务流程宣教',
    id: 'xuanjiao',
    icon: require('./assets/navs/服务流程@2x.png')
  },
  {
    name: '预约挂号',
    id: 'book',
    path: '/book/rule',
    icon: require('./assets/navs/预约挂号@2x.png')
  }
]

/**
 *
 * @type {string}
 */
export const dhry_orderinfo_cache_key = 'dhry_orderinfo_cache_key'

export const dhry_order_visited_ids_cache_key = 'dhry_order_visited_ids';

/**
 * 等候入院-检查状态
 * @type {{"0": string, "1": string, "2": string}}
 */
export const dhry_jc_status = {
  0: '待预约', 1: '待检查', 2: '已完成'
}

// 等候入院-检验状态
export const dhry_jy_status = {
  1: '未检查', 2: '已完成'
}

// 等候入院检验检查院区列表
export const dhry_jyjc_hos = {
  0: '解放路院区', 2: '滨江院区', 5: '城东院区', 7: '博奥院区'
}

// 导诊单cache key;
export const DZD_LIST = 'dzd_list';

export const handlerDhryAddressList = (list) => {
  let res = [];
  const hos = dhry_jyjc_hos;
  for (let item of list) {
    let str = ''
    for (let itemKey in item) {
      str += `${hos[itemKey]}${item[itemKey]}`;
    }
    res.push(str);
  }
  return res;
}




// WEBPACK FOOTER //
// ./src/page/dhry/config.js